export default __webpack_public_path__ + "static/media/ganzkoerper-reward-funnel-1.68fb8ee8.png";